import Vue from "vue";

class AuthService {
  static login(payload) {
    const url = "admin/auth/login";

    return Vue.axios.post(url, payload);
  }

  static forgotPassword(payload) {
    const url = "admin/auth/forgot-password";

    return Vue.axios.post(url, payload);
  }

  static resetPassword(slug, payload) {
    const url = `admin/auth/reset-password/${slug}`;

    return Vue.axios.post(url, payload);
  }

  static verifyResetPasswordSlug(slug) {
    const url = `admin/auth/reset-password/${slug}`;

    return Vue.axios.get(url);
  }
}

export default AuthService;
